(function ($, window) {
	'use strict';

	$(function () {
		const heroVideo = document.querySelector('.js-hero-video');
		const heroPauses = document.querySelectorAll('.js-hero-pause');

		const changeButtonStates = (buttons, state) => {
			buttons.forEach(pauseButton => {
				const buttonLabel = pauseButton.querySelector('.js-hero-pause-language');
				const buttonIcon = pauseButton.querySelector('.js-hero-pause-icon');
				let iconUse = buttonIcon.querySelector('use') ?? false;

				if (buttonLabel) {
					buttonLabel.innerHTML = state.charAt(0).toUpperCase() + state.slice(1);
				}

				if (buttonIcon) {
					buttonIcon.setAttribute('class', `hero__control-icon icon--${state}  js-hero-pause-icon`);
				}

				if (iconUse) {
					iconUse.setAttribute('xlink:href', `#svg-${state}`);
				}
			});
		};

		if (heroVideo) {
			heroPauses.forEach(pauseButton => {
				pauseButton.addEventListener('click', () => {
					if (heroVideo.paused) {
						heroVideo.play();
					} else {
						heroVideo.pause();
					}
				});
			})

			heroVideo.addEventListener('play', () => {
				changeButtonStates(heroPauses, 'pause');
			});

			heroVideo.addEventListener('pause', () => {
				changeButtonStates(heroPauses, 'play');
			});
		}

	});
})(jQuery, window);
